import type { ReactNode } from "react"

type PromoBadgeProps = {
  children: ReactNode
  className?: string
}

export default function PromoBadge({ children, className }: PromoBadgeProps) {
  return (
    <div
      className={`storefront-site-badge storefront-product-badge ${className || ""}`.trim()}
      style={{
        backgroundColor: "var(--storefront-site-badge-bg, #000)",
        color: "var(--storefront-site-badge-text, #fff)",
      }}
    >
      {children}
    </div>
  )
}
